import type { ReactNode } from 'react';
import BulletPoint from '@classify/react-core-components/BulletPoint';
import { Variant } from '@classify/react-core-components/Typography';
import { useTheme } from '@classify/react-core-components/styles';

interface Props {
  children: string | ReactNode;
  color?: 'promotion' | 'info';
  variant?: Variant;
}

const HighlightedBulletPoint = ({
  children,
  color = 'promotion',
  variant = 'subheading',
  ...otherProps
}: Props) => {
  const { palette } = useTheme();
  const highlightColors = {
    promotion: palette.content.highlight.secondLevel.background,
    info: palette.notification.info.background,
  };
  return (
    <BulletPoint
      marker="check"
      variant={variant}
      sx={{ backgroundColor: highlightColors[color], borderRadius: 'radius.field' }}
      {...otherProps}
    >
      {children}
    </BulletPoint>
  );
};

export default HighlightedBulletPoint;
